// @ts-ignore
import Swiper from 'swiper';
import {
  A11y,
  Autoplay,
  EffectCards,
  EffectFade,
  EffectFlip,
  Keyboard,
  Navigation,
  Pagination,
  Scrollbar,
  Virtual,
  Zoom,
} from 'swiper/modules';
import { paramsList } from './params-list';
import { extend, isObject } from './utils';
type KeyValueType = { [x: string]: any };
export const allowedParams = paramsList.map((key) => key.replace(/_/, ''));

/** Modules needed by historical Swiper.use([...]) call sites across the app. */
export const COMPAT_SWIPER_MODULES = [
  A11y,
  Autoplay,
  EffectCards,
  EffectFade,
  EffectFlip,
  Keyboard,
  Navigation,
  Pagination,
  Scrollbar,
  Virtual,
  Zoom,
];

export function getParams(obj: any = {}) {
  const params: any = {
    on: {},
    modules: COMPAT_SWIPER_MODULES,
  };
  const passedParams: KeyValueType = {};
  if (Swiper?.defaults) {
    extend(params, Swiper.defaults);
  }
  if (Swiper?.extendedDefaults) {
    extend(params, Swiper.extendedDefaults);
  }
  params._emitClasses = true;
  params.init = false;
  params.modules = COMPAT_SWIPER_MODULES;

  const rest: KeyValueType = {};
  const allowed = paramsList.map((key) => key.replace(/_/, ''));
  Object.keys(obj).forEach((key: string) => {
    const _key = key.replace(/^_/, '');
    if (allowed.indexOf(_key) >= 0) {
      if (isObject(obj[key])) {
        params[_key] = {};
        passedParams[_key] = {};
        extend(params[_key], obj[key]);
        extend(passedParams[_key], obj[key]);
      } else {
        params[_key] = obj[key];
        passedParams[_key] = obj[key];
      }
    } else {
      rest[_key] = obj[key];
    }
  });
  ['navigation', 'pagination', 'scrollbar'].forEach((key) => {
    if (params[key] === true) params[key] = {};
    if (params[key] === false) delete params[key];
  });

  return { params, passedParams, rest };
}
